import React from 'react';

const MarketingContent = () => {
  const metrics = [
    { name: 'Campaigns', value: '24' },
    { name: 'Active Users', value: '1,248' },
    { name: 'Conversion Rate', value: '3.2%' },
  ];

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Marketing Analytics</h2>
      <div className="bg-white rounded-lg shadow p-4">
        <AnalyticsChart />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {metrics.map((metric) => (
            <MetricCard key={metric.name} name={metric.name} value={metric.value} />
          ))}
        </div>
      </div>
    </div>
  );
};

const AnalyticsChart = () => {
  return (
    <div className="h-64 flex items-center justify-center bg-gray-100 mb-4">
      <p className="text-gray-500">Analytics Dashboard Placeholder</p>
    </div>
  );
};

const MetricCard = ({ name, value }) => {
  return (
    <div className="border rounded p-4">
      <h3 className="font-medium">{name}</h3>
      <p className="text-2xl font-bold">{value}</p>
    </div>
  );
};

export default MarketingContent;